var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.604,
    height: 15.713,
    viewBox: "0 0 91.604 15.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187042",
    "data-name": "Group 187042",
    transform: "translate(-55 38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214903",
    "data-name": "Path 214903",
    d: "M420.09,0l-2.128,5.758L411.829,6l4.819,3.8-1.664,5.909L420.09,12.3l5.105,3.408L423.532,9.8,428.351,6l-6.134-.244Z",
    transform: "translate(-300.517 -38)",
    fill: "#ff9f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214904",
    "data-name": "Path 214904",
    d: "M557.365,0l-2.127,5.758L549.1,6l4.819,3.8-1.664,5.909,5.106-3.408,5.106,3.408L560.808,9.8,565.627,6l-6.134-.244Z",
    transform: "translate(-419.022 -38)",
    fill: "#c7c9cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214905",
    "data-name": "Path 214905",
    d: "M145.538,0l-2.127,5.758L137.277,6,142.1,9.8l-1.663,5.909,5.106-3.408,5.105,3.408L148.98,9.8,153.8,6l-6.134-.244Z",
    transform: "translate(-63.506 -38)",
    fill: "#ff9f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214906",
    "data-name": "Path 214906",
    d: "M282.813,0l-2.127,5.758L274.552,6l4.819,3.8-1.664,5.909,5.106-3.408,5.106,3.408L286.256,9.8,291.074,6l-6.134-.244Z",
    transform: "translate(-182.011 -38)",
    fill: "#ff9f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214907",
    "data-name": "Path 214907",
    d: "M8.261,0,6.134,5.757,0,6,4.819,9.8,3.156,15.713,8.261,12.3l5.106,3.408L11.7,9.8,16.522,6l-6.134-.244Z",
    transform: "translate(55 -38)",
    fill: "#ff9f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupStar);
export default __webpack_public_path__ + "static/media/groupStar.c9f6495932afbc0f708d65bb26b35f1e.svg";
export { ForwardRef as ReactComponent };